<template>
	<dropdown
		:id="id"
		:button-class="'link-selector ' + extraButtonClass"
		container-class="dropdown-light"
		:aria-label="ariaLabelText"
	>
		<template #label><span v-output="label"></span> <span class="caret"></span></template>
		<li v-for="link in parsedLinks" :key="link.link">
			<a v-output="link.name" :href="baseUrl + link.link" class="dropdown-menu-item"></a>
		</li>
	</dropdown>
</template>

<script>
import { Dropdown } from 'vue-bootstrap';
import { computed } from 'vue';
import { stripTags } from '@/lib/string';

/**
 * The LinkSelector component.
 *
 * Expects an array of links:
 *
 * [
 *	 { link: 'http://af.dev/2018', name: '2018' },
 *	 { link: 'http://af.dev/2019', name: '2019' }
 * ]
 *
 */
export default {
	components: {
		Dropdown,
	},
	props: {
		id: {
			type: String,
			default: 'link-selector',
		},
		links: {
			type: Array,
			required: true,
		},
		activeLink: {
			type: String,
			default: '',
		},
		baseUrl: {
			type: String,
			default: '',
		},
		extraButtonClass: {
			type: String,
			default: '',
		},
		ariaLabel: {
			type: String,
			default: '',
		},
	},
	setup(props) {
		const getSelectedLink = () => {
			const firstLink = props.links[0];
			return props.activeLink ? props.activeLink : firstLink.link;
		};

		const label = computed(() => {
			if (!props.links.length) {
				return;
			}

			const selectedLink = getSelectedLink();

			return stripTags(props.links.find((link) => link.link?.toString() === selectedLink)?.name, false, false);
		});

		const ariaLabelText = computed(() => stripTags(props.ariaLabel || label.value, true));
		const parsedLinks = computed(() => props.links.map((link) => ({ ...link, name: stripTags(link.name, true) })));

		return {
			label,
			ariaLabelText,
			parsedLinks,
		};
	},
};
</script>
